export default __webpack_public_path__ + "static/logo-main-white-5e7f354c5b5d4d4ce7c95cb3bd760348.png";